import React, { useState } from 'react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function FinalCTA() {
  const [showVideo, setShowVideo] = useState(false);
  return <footer className="bg-slate-900 text-white" data-id="element-45">
      {/* CTA Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center border-b border-slate-800" data-id="element-46">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-47">
          Give every client project a single source of truth.
        </h2>
        <p className="text-xl text-slate-400 mb-10 max-w-2xl mx-auto" data-id="element-48">
          Stop rebuilding SOWs and spreadsheets from scratch for every ERP
          implementation.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-49">
          <Button size="lg" className="bg-gradient-primary hover:bg-gradient-primary-hover text-white shadow-lg shadow-primary-blue/30" onClick={() => window.open('https://calendly.com/alex-thruline/erp-client-portal', '_blank')} data-id="element-50">
            Schedule Demo
          </Button>
          <motion.button onClick={() => setShowVideo(true)} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center h-12 px-6 text-base font-medium rounded-lg border-2 border-slate-600 bg-slate-800 text-slate-200 hover:border-transparent hover:bg-gradient-primary hover:text-white transition-all duration-300" data-id="element-51">
            Watch Demo
          </motion.button>
        </div>
      </div>

      {/* Footer Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-52">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-53">
          <div className="flex items-center gap-3" data-id="element-54">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/46nVjihkQgtRGHjwuLjy14/Untitled_design_%282%29.png" alt="Foundations" className="h-8 w-8" data-id="element-55" />
            <div data-id="element-56">
              <div className="font-bold text-lg" data-id="element-57">Foundations</div>
              <div className="flex items-center gap-1.5 text-xs text-slate-400" data-id="element-58">
                <span data-id="element-59">Powered by</span>
                <a href="https://www.thruline.ai" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" data-id="element-60">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bxVHxBAzSWANMpXq8oviFD/thruline-logo-light-trans_%281%29.png" alt="Thruline" className="h-5 w-auto brightness-200" data-id="element-61" />
                </a>
              </div>
            </div>
          </div>

          <div className="flex gap-8 text-sm text-slate-400" data-id="element-62">
            <a href="https://www.thruline.ai" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-63">
              Back to Thruline
            </a>
            <a href="https://www.thruline.ai/company/terms-conditions#privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-64">
              Privacy
            </a>
            <a href="https://www.thruline.ai/company/terms-conditions#privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-65">
              Terms
            </a>
          </div>

          <div className="text-sm text-slate-500" data-id="element-66">
            © {new Date().getFullYear()} Thruline Inc.
          </div>
        </div>
      </div>

      {/* Video Modal */}
      <AnimatePresence data-id="element-67">
        {showVideo && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={() => setShowVideo(false)} data-id="element-68">
            <motion.div initial={{
          scale: 0.9
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0.9
        }} className="bg-white rounded-2xl p-6 max-w-5xl w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-69">
              <div className="flex items-center justify-between mb-4" data-id="element-70">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-71">
                  Product Demo
                </h3>
                <button onClick={() => setShowVideo(false)} className="text-slate-600 hover:text-slate-900 transition-colors p-2 hover:bg-slate-100 rounded-lg" data-id="element-72">
                  <X className="h-6 w-6" data-id="element-73" />
                </button>
              </div>
              <div className="aspect-video rounded-lg overflow-hidden bg-slate-100" data-id="element-74">
                <iframe src="https://www.loom.com/embed/224e54ecaf844fcc9e98db1fc3a2236a?sid=8f3e4c5d-9b0a-4f3e-8e5d-9c8f7e6d5c4b" frameBorder="0" allowFullScreen className="w-full h-full" data-id="element-75"></iframe>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}